import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SettingsService } from '@app/core/settings/settings.service';
import { CanActivate, CanActivateChild } from '@angular/router';

@Injectable()
export class RedirectToExternalPageGuard implements CanActivate, CanActivateChild {
  private settingsService = inject(SettingsService);


  public canActivate(): Observable<boolean> {
    return this.redirectWhenApplicableObservable();
  }

  public canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }

  private redirectWhenApplicableObservable(): Observable<boolean> {
    const settings = this.settingsService.settings;

    if (settings.shouldRedirectToExternalUrl()) {
      window.location.href = settings.redirection_url;
    }

    return of(true);
  }
}
